import React, { useContext } from "react";
import { SimpleContext } from "../../../../../store/context/simple-context";
import PropTypes from "prop-types";
import parse from "html-react-parser";
import Mark from "./Mark";

const Info = ({ number, normal }) => {
  const {
    translate: { t },
  } = useContext(SimpleContext);

  return (
    <p className="GP-C-T-T-tr-td-info">
      <Mark mark="ok" customClass="GP-C-T-T-tr-td-info__mark" />
      <span className="GP-C-T-T-tr-td-info__text">
        {number && (
          <b>
            {number.toLocaleString(t("language code"), { useGrouping: true })}
          </b>
        )}
        {parse(t(normal))}
      </span>
    </p>
  );
};
Info.propTypes = {
  number: PropTypes.number,
  normal: PropTypes.string,
};
export default Info;
